import reducer, { initialState } from '../../reducers/association/getCustomers';
import * as actions from '../../actions/association';

const fn = { reducer, initialState, actions };
export default fn;
